import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=b0eac896"
import script from "./Crear.vue?vue&type=script&lang=js"
export * from "./Crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0eac896')) {
      api.createRecord('b0eac896', component.options)
    } else {
      api.reload('b0eac896', component.options)
    }
    module.hot.accept("./Crear.vue?vue&type=template&id=b0eac896", function () {
      api.rerender('b0eac896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/aspectos/Crear.vue"
export default component.exports